<app-saved-searches-card
    class="w-full h-full"
    [isLoading]="isRecentSavedSearchLoading$ | async"
    [savedSearchesData]="(savedSearchesData$ | async)?.items"
    (recentSavedSearchEvent)="onRecentSavedSearchEvent($event)"
></app-saved-searches-card>
